import { queryOptions } from '@tanstack/react-query';

import { fetchBackend } from './apiClient';

export const userQueries = {
  all: () => ['user'],
  byEmail: (email: string) => [userQueries.all(), { email }],
  exists: (email: string) =>
    queryOptions({
      queryKey: [...userQueries.byEmail(email), 'exists'],
      queryFn: () => userExists(email),
    }),

  current: () =>
    queryOptions({
      queryKey: [userQueries.all(), 'current'],
      queryFn: async (): Promise<UserData> => {
        const response = await fetchBackend('/user/current', {
          method: 'GET',
        });
        try {
          if (!response.ok) {
            throw new Error('Failed to fetch user data');
          }
          const res = (await response.json()) as {
            user: {
              superuser: boolean;
            };
          };

          return res.user;
        } catch (error) {
          console.error('Error fetching user data:', error);
          throw error;
        }
      },
    }),
} as const;

const userExists = async (email: string): Promise<{ exists: boolean }> => {
  const response = await fetchBackend(`/user/${email}/exists`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error('Failed to check if user exists');
  }

  const data = (await response.json()) as { exists: boolean };

  return data;
};

interface UserData {
  superuser: boolean;
}
